import "core-js/features/array/at";
import { ApolloProvider } from "@apollo/client";
import type { AppProps } from "next/app";
import Head from "next/head";
import React from "react";

import { GtmProvider } from "src/analytics/GtmProvider";
import { HistoryProvider } from "src/hooks/useHistory";
import { LoadingOverlayProvider } from "src/hooks/useLoading";
import { initializeDatadogRum } from "src/lib/monitoring/datadog";
import { MomoChakraProvider } from "src/providers/MomoChakraProvider";
import { SentryProvider } from "src/providers/SentryProvider";
import { useApollo } from "src/store/useApollo";

// ボタンのアウトラインを、キーボード操作の場合のみ表示し、マウス操作の場合は非表示にする
import "focus-visible/dist/focus-visible";

initializeDatadogRum();

const App = ({ Component, pageProps }: AppProps) => {
  const apolloClient = useApollo();

  return (
    <>
      <Head>
        <title>クロンスマートパス</title>
      </Head>

      <ApolloProvider client={apolloClient}>
        <SentryProvider>
          <GtmProvider>
            <MomoChakraProvider>
              <LoadingOverlayProvider>
                <HistoryProvider>
                  <Component {...pageProps} />
                </HistoryProvider>
              </LoadingOverlayProvider>
            </MomoChakraProvider>
          </GtmProvider>
        </SentryProvider>
      </ApolloProvider>
    </>
  );
};

export default App;
